import React from 'react'
import Cross from 'sushiweb/Icons/all/Cross'
import Modal from 'sushiweb/Modal/Modal'
import PromotionsCard from '../../../shared/home/PromotionsCard'
import styles from "./SuggestionModal.module.scss"

function SuggestionModal({
  suggestionStatus,
  suggestions,
  toastOpenHandler,
  onClose,
  visible,
  clearIssues,
  title,
  cartUpdateSource,
  type
}) {
  return (
    <Modal
      visible={visible}
      type="default"
      isCentered
      showCloseIcon={false}
      onClose={onClose}
      className={styles.alternateProducts}
      titleComponent={
        <div className={styles.header}>
          <div className="w-800 text-gray-800 fs-24">{title}</div>
          <Cross className="pointer" size={24} onClick={onClose} />
        </div>
      }
    >
      <div className={styles.alternateProductsSection}>
        <PromotionsCard
          promotionProductsStatus={suggestionStatus}
          promotionsData={suggestions}
          toastOpenHandler={toastOpenHandler}
          type="requestProduct"
          cartUpdateSource={cartUpdateSource}
          dontOpenIssueModal={true}
          isIssuesModalOpen={false}
          clearIssues={clearIssues}
          getCartSummary={type === "trial"}
        />
      </div> 
    </Modal>
  )
}

export default SuggestionModal
